/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { Amount } from './Amount';
// @ts-ignore
import {
// @ts-ignore
    AmountFromJSON,
// @ts-ignore
    AmountFromJSONTyped,
// @ts-ignore
    AmountToJSON,
} from './Amount';

/**
 * 
 * @export
 * @interface OrderItemUpdate
 */
export interface OrderItemUpdate {
    /**
     * 
     * @type {string}
     * @memberof OrderItemUpdate
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof OrderItemUpdate
     */
    confirmedQuantity?: number;
    /**
     * 
     * @type {Amount}
     * @memberof OrderItemUpdate
     */
    confirmedLineItemPrice?: Amount;
    /**
     * 
     * @type {Amount}
     * @memberof OrderItemUpdate
     */
    confirmedDiscountAmount?: Amount;
}

/**
 * Check if a given object implements the OrderItemUpdate interface.
 */
// @ts-ignore
export function instanceOfOrderItemUpdate(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

// @ts-ignore
export function OrderItemUpdateFromJSON(json: any): OrderItemUpdate {
    return OrderItemUpdateFromJSONTyped(json, false);
}

// @ts-ignore
export function OrderItemUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderItemUpdate {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'confirmedQuantity': !exists(json, 'confirmed_quantity') ? undefined : json['confirmed_quantity'],
        'confirmedLineItemPrice': !exists(json, 'confirmed_line_item_price') ? undefined : AmountFromJSON(json['confirmed_line_item_price']),
        'confirmedDiscountAmount': !exists(json, 'confirmed_discount_amount') ? undefined : AmountFromJSON(json['confirmed_discount_amount']),
    };
}

// @ts-ignore
export function OrderItemUpdateToJSON(value?: OrderItemUpdate | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'confirmed_quantity': value.confirmedQuantity,
        'confirmed_line_item_price': AmountToJSON(value.confirmedLineItemPrice),
        'confirmed_discount_amount': AmountToJSON(value.confirmedDiscountAmount),
    };
}

